export const PRACTITIONER_CAMPAIGN_PROCESS_NAME = 'soulwise-practitioner-campaign';
export const PRACTITIONER_CAMPAIGN_PROCESS_ALIAS = 'soulwise-practitioner-campaign/release-1';
export const CAMPAIGN_LISTING_TYPE = 'campaign-inbox';
export const CAMPAIGN_LISTING_TITLE = '[System] Inbox';

export const isPractitionerCampaignProcess = processName => {
  const base = typeof processName === 'string' ? processName.split('/')[0].trim() : '';
  return base === PRACTITIONER_CAMPAIGN_PROCESS_NAME;
};

export const isCampaignInboxListing = listing => {
  const listingType = listing?.attributes?.publicData?.listingType;
  const title = listing?.attributes?.title;
  return listingType === CAMPAIGN_LISTING_TYPE || title === CAMPAIGN_LISTING_TITLE;
};

export const campaignProtectedData = transaction => transaction?.attributes?.protectedData || {};

export const campaignTitleFromTransaction = transaction => {
  const title = campaignProtectedData(transaction).campaignTitle;
  return typeof title === 'string' && title.trim() ? title.trim() : null;
};

export const campaignBodyFromTransaction = transaction => {
  const body = campaignProtectedData(transaction).campaignBody;
  return typeof body === 'string' && body.trim() ? body : null;
};

const entityId = entity => entity?.id?.uuid || entity?.id || null;

export const campaignBodyAsMessage = transaction => {
  const body = campaignBodyFromTransaction(transaction);
  if (!body || !transaction?.id) {
    return null;
  }
  const createdAt =
    transaction.attributes?.lastTransitionedAt || transaction.attributes?.createdAt || new Date(0);
  return {
    id: { uuid: `campaign-body-${entityId(transaction)}` },
    type: 'message',
    attributes: {
      content: body,
      createdAt: createdAt instanceof Date ? createdAt : new Date(createdAt),
    },
    sender: transaction.customer,
  };
};

export const messagesWithCampaignBody = (transaction, messages = []) => {
  if (!isPractitionerCampaignProcess(transaction?.attributes?.processName)) {
    return messages || [];
  }
  const synthetic = campaignBodyAsMessage(transaction);
  if (!synthetic) {
    return messages || [];
  }
  const alreadyPresent = (messages || []).some(message => message?.id?.uuid === synthetic.id.uuid);
  return alreadyPresent ? messages : [synthetic, ...(messages || [])];
};

/**
 * Practitioner is the Sharetribe customer (role swap). Hide the thread from
 * them until the recipient (provider) replies with a real Sharetribe message.
 */
export const shouldShowCampaignConversation = (transaction, currentUserId) => {
  if (!isPractitionerCampaignProcess(transaction?.attributes?.processName)) {
    return true;
  }
  const practitionerId = entityId(transaction?.customer);
  const recipientId = entityId(transaction?.provider);
  if (currentUserId && currentUserId === recipientId) {
    return true;
  }
  if (currentUserId && currentUserId === practitionerId) {
    return (transaction?.messages || []).some(message => entityId(message?.sender) === recipientId);
  }
  // Unknown viewer: only show if there is a recipient reply.
  return (transaction?.messages || []).some(message => entityId(message?.sender) === recipientId);
};
